import * as React from 'react';
import Avatar from '@material-ui/core/Avatar';
import ChatIcon from '@material-ui/icons/Chat';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import moment from 'moment';

import * as notificationInterfaces from '../interfaces';

export function NotificationListItem({ data, onClick, selected }: notificationInterfaces.INotificationsListItemProps) {
    return (
        <ListItem button onClick={evt => onClick(evt, data.id)} selected={selected}>
            <ListItemAvatar>
                <Avatar>
                    <ChatIcon />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={`${data.text}`}
                secondary={`${data.recipientCount} recipients ${moment(data.timestamp).fromNow() || ''}`}
            />
        </ListItem>
    );
}

export default NotificationListItem;
